export const thumbnail = (item, small = false, defaultVal = false) => {
  if (item.thumbnail !== undefined) {
    switch (item.thumbnail) {
      case null:
        if (item.extension) {
          return `/img/fileicons/small/${item.extension.replace(".", "")}.svg`;
        } else if (defaultVal) {
          return `/img/fileicons/small/${defaultVal.replace(".", "")}.svg`;
        } else {
          return false;
        }
      default:
        if (small && item.resforweb) {
          return item.resforweb;
        } else {
          return item.thumbnail.replace(
            "gerowonen-sheprd.ams3.digitaloceanspaces.com",
            "cdn-gerowonen.sheprd.app"
          );
        }
    }
  }

  if (defaultVal) {
    return `/img/fileicons/small/${defaultVal.replace(".", "")}.svg`;
  }

  return false;
};

export const placeholderThumb = () => {
  return `/img/fileicons/small/unknown.svg`;
};

export const errorPlaceholder = (e) => {
  e.currentTarget.src = placeholderThumb();
};
